export const TODO_COLORS = [
  { label: "Blauw", value: "#93B5C6" },
  { label: "Groen", value: "#A7C4A0" },
  { label: "Perzik", value: "#E8B78F" },
  { label: "Roze", value: "#D9A5A5" },
  { label: "Paars", value: "#B9A5D9" },
  { label: "Geel", value: "#E5C687" },
];

// Readable text colour (dark) for these soft pastel backgrounds.
export const onColor = "#3B322F";
